
import MeaPage from "../../../components/MeaPage";
import TrainingHeader from "./components/TrainingHeader";
import { useRef } from "react";
import { useParams } from "react-router-dom";
import UpdateTrainingModal from "./components/UpdateTrainingModal";
import trainingsAPI from "../../../services/trainings";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import TrainingTilesComponent from "./components/TrainingTilesComponent";

const TrainingInfoPage = () => {

  //
  const updateModalRef = useRef();
  const toast = useRef();
  //
  const params = useParams();
  const schoolId = params.schoolId
  const trainingId = params.trainingId;
  const accessToken = "";
  const trainingQuery = trainingsAPI.GetOne(
    schoolId,
    trainingId,
    accessToken
  );
  const trainingObj = trainingQuery?.data?.data;
  //
  return (
    <>
      <MeaPage header={<TrainingHeader training={trainingObj} query={trainingQuery} />} showBackButton={false}>


        <TrainingTilesComponent training={trainingObj} />


        <ConfirmDialog />
        <Toast ref={toast} />

        <UpdateTrainingModal ref={updateModalRef} training={trainingObj} schoolId={schoolId} trainingId={trainingId} />
      </MeaPage>
    </>
  );
};
export default TrainingInfoPage;
